import { when } from "util/support";
import useUser from "features/auth/useUser";
import navConfig from "./config";

export default function useNavConfig() {
    const { hasRole } = useUser();

    const getConfig = () => (
        navConfig.reduce((config, navConfigItem) => [
            ...config,
            {
                ...navConfigItem,
                items: navConfigItem.items
                    .reduce((items, item) => when(
                        hasRole(item.roles),
                        () => [
                            ...items,
                            {
                                ...item,
                                children: item.children?.filter(({ roles }) => hasRole(roles))
                            }
                        ],
                        items
                    ), [] as typeof navConfigItem.items),
            }
        ], [] as typeof navConfig)
    );

    return {
        getConfig
    };
};
